export const OC_QUOTE_REDEMPTION_SEARCH = {
  desktop: ` <div class="cui-grid cui-container -spacing--top-32 -spacing--bottom-64">
  <div class="cui-row">
    <div class="cui-col-xl-10 cui-col-lg-12">

      <div class="cui-skeleton-paragraph -spacing--bottom-32">
        <div class="cui-skeleton-paragraph__content" style="width: 160px">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--bottom-32">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-row -spacing--bottom-48">
        <div class="cui-col-lg-3 cui-col-md-3 cui-col-sm-4">
          <div class="cui-skeleton-input -size--medium">
            <div class="cui-skeleton-input__content" style="width: 100%;">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
            </div>
          </div>
        </div>
        <div class="cui-col-lg-2 cui-col-md-2 cui-col-sm-4">
          <div class="cui-skeleton-button -size--large">
            <div class="cui-skeleton-button__content" style="width: 100%;">
              <div class="cui-skeleton__item cui-skeleton-button__button"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-skeleton-heading -size--medium -spacing--bottom-32">
        <div class="cui-skeleton-heading__content" >
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 120px">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 52px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>
      <div class="cui-skeleton-rectangle -spacing--bottom-4 -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 60px;"></div>
      </div>

    </div>
  </div>
</div>`
};
